import Payments from "./Payments"

export default Payments
